"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.initialState = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        if (this.canMove()) this.doMove("left");
    }
    moveRight() {
        if (this.canMove()) this.doMove("right");
    }
    moveUp() {
        if (this.canMove()) this.doMove("up");
    }
    moveDown() {
        if (this.canMove()) this.doMove("down");
    }
    doMove(direction) {
        const previousState = JSON.stringify(this.getState());
        let board = JSON.parse(JSON.stringify(this.getState()));
        if (direction === "up" || direction === "down") board = this.transposeBoard(board);
        if (direction === "right" || direction === "down") board = board.map((row)=>row.slice().reverse());
        for(let i = 0; i < 4; i++){
            const row = board[i].filter((cell)=>cell !== 0);
            let j = 0;
            while(j < row.length - 1){
                if (row[j] === row[j + 1]) {
                    row[j] *= 2;
                    this.score += row[j];
                    row.splice(j + 1, 1);
                }
                j++;
            }
            while(row.length < 4)row.push(0);
            board[i] = row;
        }
        if (direction === "right" || direction === "down") board = board.map((row)=>row.slice().reverse());
        if (direction === "up" || direction === "down") board = this.transposeBoard(board);
        this.setState(board);
        if (previousState !== JSON.stringify(this.getState())) {
            this.status = "playing";
            this.getRandomFreePosition();
            this.checkGameStatus();
        }
    }
    checkGameStatus() {
        if (this.getState().some((row)=>row.some((cell)=>cell === 2048))) {
            this.status = "win";
            return;
        }
        const boardFull = this.getState().every((row)=>row.every((cell)=>cell !== 0));
        if (boardFull && !this.canMove()) this.status = "lose";
    }
    updateGameStatus() {
        const gameStatus = this.getStatus();
        const messageStart = document.querySelector(".message-start");
        const messageWin = document.querySelector(".message-win");
        const messageLose = document.querySelector(".message-lose");
        const startButton = document.querySelector(".start");
        messageStart.classList.add("hidden");
        messageWin.classList.add("hidden");
        messageLose.classList.add("hidden");
        if (gameStatus === "idle") {
            messageStart.classList.remove("hidden");
            startButton.classList.remove("restart");
            startButton.textContent = "Start";
        } else if (gameStatus === "win") {
            messageWin.classList.remove("hidden");
            startButton.classList.add("restart");
            startButton.textContent = "Restart";
        } else if (gameStatus === "lose") {
            messageLose.classList.remove("hidden");
            startButton.classList.add("restart");
            startButton.textContent = "Restart";
        } else if (gameStatus === "playing") {
            startButton.classList.add("restart");
            startButton.textContent = "Restart";
        }
    }
    getScore() {
        return this.score;
    }
    getRandomFreePosition() {
        let firstNumber, secondNumber;
        do {
            firstNumber = Math.floor(Math.random() * 4);
            secondNumber = Math.floor(Math.random() * 4);
        }while (this.initialState[firstNumber][secondNumber]);
        this.initialState[firstNumber][secondNumber] = this.generateRandomNumber();
    }
    generateRandomNumber(probOf2 = 0.9) {
        const random = Math.random();
        if (random <= probOf2) return 2;
        else return 4;
    }
    getState() {
        return this.initialState;
    }
    setState(newState) {
        this.initialState = newState;
    }
    canMove() {
        const board = this.getState();
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            if (board[i][j] === 0) return true;
        }
        for(let i = 0; i < 4; i++)for(let j = 0; j < 3; j++){
            if (board[i][j] === board[i][j + 1]) return true;
        }
        for(let i = 0; i < 3; i++)for(let j = 0; j < 4; j++){
            if (board[i][j] === board[i + 1][j]) return true;
        }
        return false;
    }
    updateView(htmlBoard) {
        const board = this.getState();
        for(let i = 0; i < 4; i++)for(let j = 0; j < 4; j++){
            const cell = htmlBoard.rows[i].cells[j];
            cell.textContent = "";
            cell.className = "field-cell";
            if (board[i][j] !== 0) {
                cell.textContent = board[i][j];
                cell.classList.add("field-cell--" + board[i][j]);
            }
        }
        const scoreElement = document.querySelector(".game-score");
        if (scoreElement) scoreElement.textContent = this.getScore();
        this.updateGameStatus();
    }
    getStatus() {
        return this.status;
    }
    start() {
        this.status = "playing";
        this.getRandomFreePosition();
        this.getRandomFreePosition();
    }
    transposeBoard(board) {
        const size = board.length;
        const transposed = Array(size).fill().map(()=>Array(size).fill(0));
        for(let i = 0; i < size; i++)for(let j = 0; j < size; j++)transposed[i][j] = board[j][i];
        return transposed;
    }
    restart() {
        this.initialState = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$gameField = document.querySelector("tbody");
const $09e991522ca7e64e$var$button = document.querySelector(".button");
document.addEventListener("keydown", $09e991522ca7e64e$var$clickHandler);
$09e991522ca7e64e$var$button.addEventListener("click", $09e991522ca7e64e$var$startHandler);
function $09e991522ca7e64e$var$startHandler() {
    if ($09e991522ca7e64e$var$button.classList.contains("restart")) {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$game.updateView($09e991522ca7e64e$var$gameField);
    } else {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$game.updateView($09e991522ca7e64e$var$gameField);
    }
}
function $09e991522ca7e64e$var$clickHandler(event) {
    switch(event.key){
        case "ArrowUp":
            $09e991522ca7e64e$var$game.moveUp();
            $09e991522ca7e64e$var$game.updateView($09e991522ca7e64e$var$gameField);
            break;
        case "ArrowDown":
            $09e991522ca7e64e$var$game.moveDown();
            $09e991522ca7e64e$var$game.updateView($09e991522ca7e64e$var$gameField);
            break;
        case "ArrowLeft":
            $09e991522ca7e64e$var$game.moveLeft();
            $09e991522ca7e64e$var$game.updateView($09e991522ca7e64e$var$gameField);
            break;
        case "ArrowRight":
            $09e991522ca7e64e$var$game.moveRight();
            $09e991522ca7e64e$var$game.updateView($09e991522ca7e64e$var$gameField);
            break;
    }
}
const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();


//# sourceMappingURL=index.6a0e0023.js.map
